<template>
  <div class="new-candidate-portal-page">
    <iframe
      class="new-candidate-portal-frame"
      src="/new-candidate-portal.html"
      title="TalentFind Candidate Portal - Hybrid Dashboard V3"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "NewCandidatePortal",
};
</script>

<style scoped>
.new-candidate-portal-page {
  height: 100vh;
  width: 100%;
}
.new-candidate-portal-frame {
  height: 100%;
  width: 100%;
  border: none;
}
</style>
